module.exports = __webpack_public_path__ + "static/media/favicon.53e6f624.ico";